import Vue from 'vue'
Vue.directive('tooltip', {
  inserted: function (el) {
    let elems = el.parentElement.querySelectorAll('.tooltipped')
    M.Tooltip.init(elems, {})
  }
})
